import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-4 ModelField-colFirst" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Операция", -1)
const _hoisted_6 = { class: "col-2 ModelField-colLast" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Процент (%)", -1)
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Ограничения по длине (ИЛИ)", -1)
const _hoisted_10 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog",
    onOnShown: _ctx.onShown,
    height: '90vh'
  }, {
    editForm: _withCtx(({ model }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_EnumControl, {
              class: "ModelField-control",
              id: model.operation,
              "onUpdate:id": ($event: any) => ((model.operation) = $event),
              desc: model.typeDescription,
              "onUpdate:desc": ($event: any) => ((model.typeDescription) = $event),
              enumType: "volumeConstraintOperationType",
              stylingMode: "outlined"
            }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Процент...",
              min: 0,
              value: model.percent,
              "onUpdate:value": ($event: any) => ((model.percent) = $event),
              hasEmptyValue: false
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DxCheckBox, {
              class: "Dialog-checkbox",
              value: model.isRange,
              "onUpdate:value": ($event: any) => ((model.isRange) = $event),
              text: "Диапазон"
            }, null, 8, ["value", "onUpdate:value"])
          ])
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", { id: _ctx.volumeConstraintItemSubGridDomId }, null, 8, _hoisted_10)
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}